import { CMS_BLOCK_FETCH_START, CMS_BLOCK_FETCH_SUCCESS, CMS_BLOCK_FETCH_ERROR } from './types'
import type { CmsBlockAction, CmsBlocksState } from './types'

const initialState: CmsBlocksState = {}

export function cmsBlocksReducer(
  state: CmsBlocksState = initialState,
  action: CmsBlockAction,
): CmsBlocksState {
  switch (action.type) {
    case CMS_BLOCK_FETCH_START:
      return {
        ...state,
        [action.key]: { data: null, loading: true, error: false },
      }
    case CMS_BLOCK_FETCH_SUCCESS:
      return {
        ...state,
        [action.key]: { data: action.data, loading: false, error: false },
      }
    case CMS_BLOCK_FETCH_ERROR:
      return {
        ...state,
        [action.key]: { data: null, loading: false, error: true },
      }
    default:
      return state
  }
}
